import { render, staticRenderFns } from "./GameItemsList.vue?vue&type=template&id=0500c994&scoped=true&"
import script from "./GameItemsList.vue?vue&type=script&lang=js&"
export * from "./GameItemsList.vue?vue&type=script&lang=js&"
import style0 from "./GameItemsList.vue?vue&type=style&index=0&id=0500c994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0500c994",
  null
  
)

export default component.exports